<template>
  <v-container fluid py-0 px-0>
    <u-i-toolbar-admin title="Add combine order" icon="fas fa-plus"/>
    <v-layout row wrap py-4>
      <v-flex>
        <u-i-table-admin
          :headers="headers"
          :items="orders"
          with-actions
          delete-confirmation
          @delete-action="deleteItem"
          @view-action="viewOrder"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap pb-3>
      <v-flex xs12 sm6 md3 lg2 px-2>
        <v-btn @click="cancel" block black>
          Cancel
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 md3 lg2 px-2>
        <v-btn @click="confirm" black block color="primary">
          Confirm
        </v-btn>
      </v-flex>
    </v-layout>
    <modal-dialog
      :dialog="confirmDialog"
      max-width="600"
      btn-accept="Agree"
      btn-decline="Disagree"
      :title="confirmDialogTitle"
      buttons
      @accept="agree"
      @decline="disagree"
    >
      <template v-slot:content>
        <blockquote class="pa-3 blockquote">
          Combine request takes 24-48 business hours to create Consolidated invoice. If you edit your request in the
          meantime, you will lose your queue and the wait period will restart. Please also note that the resulting
          package weight might be greater than the individual package weights combined due to added packing material.
        </blockquote>
        <p class="px-3 title font-weight-medium">
          {{ feeInfo }}
        </p>
        <p class="px-3 title font-weight-medium">
          {{ freePackagesInfo }}
        </p>
        <p class="px-3 subheading font-weight-medium">
          By clicking on "Agree" below you are agreeing to the Terms and Conditions above.
        </p>
      </template>
    </modal-dialog>
  </v-container>
</template>
<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import UITableAdmin from '@/components/UI/TableAdmin.vue';
import {actionsOrder} from '@/mixins/actionsOrder';
import {common} from '@/mixins/common';
import CombinedService from '@/services/Admin/CombinedOrders';
import ModalDialog from "@/components/ModalDialog.vue";

export default {
  name: 'AdminCreateGroup',
  metaInfo: {
    titleTemplate: '%s - Admin | Add combine orders',
  },
  props: {
    ids: {
      required: true,
      type: String,
    },
    ordersForCombine: {
      required: false,
      type: Array,
      default: () => []
    },
    combineFee: {
      required: false,
      type: Number,
      default: 0
    },
    priceForPackage: {
      required: false,
      type: Number,
      default: 0
    },
    freePackagesCount: {
      required: false,
      type: Number,
      default: 0
    },
  },
  components: {
    ModalDialog,
    UITableAdmin,
    UIToolbarAdmin,
  },
  mixins: [common, actionsOrder],
  data() {
    return {
      headers: [
        {text: 'Order ID', value: 'id', prefix: '#', sortable: true, class: 'th-blue', classTagTd: ''},
        {
          text: 'MailBox',
          value: 'mailbox',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Tracking number',
          value: 'tracking_number_external',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Consignee',
          value: 'recipient_name',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Address',
          value: 'address',
          prefix: '',
          sortable: true,
          class: 'th-blue text-xs-center px-1',
          classTagTd: 'text-xs-center px-1'
        },
        {
          text: 'Actions', value: '', prefix: '', sortable: false, class: 'th-blue text-xs-center px-1', actions: [
            {action: 'view', path: 'admin/orders/view', hide: false},
            {action: 'delete', path: '', hide: false},
          ]
        }
      ],
      orders: [],
      fee: 0,
      price: 0,
      freePackages: 0,

      confirmDialog: false,
      confirmDialogTitle: 'Terms and Conditions',

      messages: {},
    }
  },
  created() {
    this.orders = this.ordersForCombine;
    this.fee = this.combineFee;
    this.price = this.priceForPackage;
    this.freePackages = this.freePackagesCount;
    if (!this.ordersForCombine.length) {
      this.getOrdersForCombine(this.ids.split(','))
    }
  },
  computed: {
    feeInfo() {
      return `Total combine price $${this.fee} for ${this.orders.length} orders`;
    },
    freePackagesInfo() {
      return `First ${this.freePackages} orders remain free of charge`;
    },
  },
  methods: {
    deleteItem(order) {
      this.orders = this.orders.filter(item => item.id !== order.id);

      if (this.orders.length < 2) {
        this.$router.push({name: 'AdminOrders'});
        this.$store.commit('setError', 'Group must have at least 2 orders');
      } else {
        let orderIds = this.ids.split(',');
        orderIds = orderIds.filter(item => parseInt(item) !== order.id);
        this.$router.replace({name: 'AdminCreateGroup', params: {ids: orderIds.join(',')}});
        this.getOrdersForCombine(orderIds);
      }
    },
    getOrdersForCombine(ids) {
      this.$store.commit('setLoading', true)
      CombinedService.getOrdersForCombine(this.buildQueryString({ids: ids}))
        .then(resp => {
          if (resp.status === this.$response.Ok) {
            this.orders = resp.data.data;
            this.fee = resp.data.combine_fee || 0;
            this.price = resp.data.price_packages_combine || 0;
            this.freePackages = resp.data.free_packages_combine || 0;
          }
        })
        .catch(err => {
          this.$store.commit('setError', err.response.data.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    confirm() {
      this.confirmDialog = true;
    },
    cancel() {
      this.$router.push({name: 'AdminOrders'});
    },
    agree() {
      this.$store.commit('setLoading', true)
      CombinedService.createGroup(this.ids.split(','))
        .then(resp => {
          if (resp.status === this.$response.Created) {
            this.$store.commit('setSuccess', resp.data.message);
            this.$router.push({name: 'AdminOrders'});
          }
        })
        .catch(err => {
          this.$store.commit('setError', err.response.data.message);
        })
        .finally(() => {
          this.$store.commit('setLoading', false);
          this.confirmDialog = false;
        });
    },
    disagree() {
      this.confirmDialog = false;
    }
  }
}
</script>
